export class AnalyticsConstants {
    public static readonly first_open = "WEB-first_open"
    public static readonly welcomeEvent = "WEB-Welcome"
    public static readonly loginEvent = "WEB-Login"
    public static readonly logoutEvent = "WEB-Logout"
    public static readonly registerEvent = "WEB-Register"
    public static readonly getUserProfileEvent = "WEB-GetUserProfile"
    public static readonly updateProfileEvent = "WEB-UpdateProfile"
    public static readonly uploadProfilePictureEvent = "WEB-UploadProfilePicture"
    public static readonly getCompanyDetailsEvent = "WEB-GetCompanyDetails"
    public static readonly updateCompanyDetailsEvent = "WEB-UpdateCompanyDetails"
    public static readonly addVenueEvent = "WEB-AddVenue"
    public static readonly updateVenueEvent = "WEB-UpdateVenue"
    public static readonly deleteVenueEvent = "WEB-DeleteVenue"
    public static readonly getVenuesEvent = "WEB-GetVenues"
    public static readonly getVenueDetailsEvent = "WEB-GetVenueDetails"
    public static readonly addVenueGalleryEvent = "WEB-AddVenueGallery"
    public static readonly updateVenueGalleryEvent = "WEB-UpdateVenueGallery"
    public static readonly getEventsEvent = "WEB-GetEvents"
    public static readonly getEventDetailsEvent = "WEB-GetEventDetails"
    public static readonly publishEventEvent = "WEB-PublishEvent"
    public static readonly cancelEventEvent = "WEB-CancelEvent"
    public static readonly addEventEvent = "WEB-AddEvent"
    public static readonly deleteEventEvent = "WEB-DeleteEvent"
    public static readonly updateEventEvent = "WEB-UpdateEvent"
    public static readonly getReservationsEvent = "WEB-GetReservations"
    public static readonly getReservationDetailsEvent = "WEB-GetReservationDetails"
    public static readonly confirmReservationEvent = "WEB-ConfirmReservation"
    public static readonly refuseReservationEvent = "WEB-RefuseReservation"
    public static readonly createHostEvent = "WEB-CreateHost"
    public static readonly getHostsByCompanyEvent = "WEB-GetHostsByCompany"
    public static readonly getHostsByVenueEvent = "WEB-GetHostsByVenue"
    public static readonly updateeHostEvent = "WEB-UpdateeHost"
    public static readonly deactiveHostEvent = "WEB-DeactiveHost"
    public static readonly forgotPasswordEvent = "WEB-ForgotPassword"
    public static readonly changePasswordEvent = "WEB-ChangePassword"
    public static readonly verifyEmailEvent = "WEB-VerifyEmail"
    public static readonly confirmPasswordEvent = "WEB-ConfirmPassword"
}